import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppIncidentSystemService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppIncidentSystems`);
    }
}
